import {fonts} from '../../../theme/foundations/fonts'
import {pxToRem} from '../../../utills/pxToRem'

export const categoryIconStyles = {
    '.cat-icon-link': {
        display: 'inline-flex',
        alignItems: 'center',
        gap: pxToRem(6),
        color: 'var(--icon-color)',
        textDecoration: 'none',
        fontFamily: fonts.primary,
        fontSize: pxToRem(16),
        fontWeight: 600,
        lineHeight: 'normal',
        letterSpacing: pxToRem(1),
        transition: 'color 0.2s ease',
        '&:hover': {
            color: 'var(--hover-color)',
            '.cat-icon-default': {
                display: 'none'
            },
            '.cat-icon-hover': {
                display: 'inline-block'
            }
        }
    },
    '.cat-icon-default': {
        width: pxToRem(18),
        height: pxToRem(18),
        objectFit: 'contain',
        flexShrink: 0,
        display: 'inline-block'
    },
    '.cat-icon-hover': {
        width: pxToRem(18),
        height: pxToRem(18),
        objectFit: 'contain',
        flexShrink: 0,
        display: 'none'
    },
    '.cat-icon-text': {
        whiteSpace: 'nowrap'
    }
}

export const megaMenuContentSlotStyles = {
    '.shop-by-brand-carousel-wrapper': {
        position: 'relative',
        width: '100%',
        maxWidth: '100%'
    },
    '.shop-by-brand-carousel-arrow': {
        display: 'none'
    },
    '.shop-by-brand-carousel': {
        display: 'flex',
        flexDirection: 'row',
        gap: {base: pxToRem(10), md: pxToRem(16)},
        p: 0,
        m: 0,
        overflow: 'hidden',
        minWidth: 0,
        width: '100%',
        listStyle: 'none',
        li: {
            listStyle: 'none',
            textAlign: 'center',
            flex: '0 0 auto',
            boxSizing: 'border-box',
            img: {
                maxWidth: '100%',
                height: 'auto',
                display: 'block'
            }
        }
    },
    '.shop-by-brand-style1': {
        '.shop-by-brand-image-wrapper-style1': {
            position: 'relative',
            width: pxToRem(230),
            height: pxToRem(230),
            display: 'inline-block',
            overflow: 'hidden',
            '@media screen and (min-width: 80em)': {
                width: pxToRem(290),
                height: pxToRem(290)
            }
        },
        '.shop-by-brand-main-image-style1': {
            width: '100%',
            height: '100%',
            display: 'block',
            objectFit: 'cover'
        },
        '.shop-by-brand-overlay-image-style1': {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            maxWidth: '55%',
            maxHeight: '55%',
            objectFit: 'contain'
        },
        '.shop-by-brand-sale-button-container-style1': {
            fontSize: {base: pxToRem(12), md: pxToRem(14)},
            m: 0,
            mt: pxToRem(10),
            fontWeight: 700,
            letterSpacing: pxToRem(1.5),
            fontFamily: fonts.primary,
            textTransform: 'uppercase',
            '.shop-by-brand-sale-button-style1': {
                color: 'black',
                textDecoration: 'none'
            }
        },
        '&:hover .shop-by-brand-sale-button-style1': {
            color: 'cav_red',
            textDecoration: 'none'
        }
    }
}
